module.exports = __webpack_public_path__ + "rw-widgets.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/react-widgets/fonts/rw-widgets.ttf?v=4.1.0
 ** module id = 570
 ** module chunks = 0
 **/